{
  "version": 1,
  "asset_id": "3af9cbe3-0452-4a5d-a7de-7b0bd357d205",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3af9cbe3-0452-4a5d-a7de-7b0bd357d205/hiatal-type-4-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3af9cbe3-0452-4a5d-a7de-7b0bd357d205/hiatal-type-4-v3-1200.webp",
  "original_filename": "hiatal-type-4-v3-1200.webp",
  "size": 186636,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:03:59Z"
}
